var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/solid/information"
  }, /*#__PURE__*/React.createElement("path", {
    id: "information",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 5.39759 5.39746 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996ZM10.8332 5.83329C10.8332 6.29353 10.4601 6.66663 9.99984 6.66663C9.5396 6.66663 9.1665 6.29353 9.1665 5.83329C9.1665 5.37306 9.5396 4.99996 9.99984 4.99996C10.4601 4.99996 10.8332 5.37306 10.8332 5.83329ZM9.1665 7.70829C8.82133 7.70829 8.5415 7.98811 8.5415 8.33329C8.5415 8.67847 8.82133 8.95829 9.1665 8.95829H9.37484V14.1666C9.37484 14.5118 9.65466 14.7916 9.99984 14.7916C10.345 14.7916 10.6248 14.5118 10.6248 14.1666V8.33329C10.6248 7.98811 10.345 7.70829 9.99984 7.70829H9.1665Z",
    fill: "#50C5D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notification_info.e6cbeb25197d89ea076b05f292a87d6d.svg";
export { ForwardRef as ReactComponent };